import {parseISO} from "date-fns";
import GeoService from "../services/geo";

export const quoteIndexMapper = (data) => {
    return {
        id: data.id,
        codeNumber: data.codeNumber,
        name: data.name,
        surname: data.surname,
        mail: data.mail,
        priceCentFrom: data.priceCentFrom,
        arrival: parseISO(data.earliestArrival),
        departure: parseISO(data.latestDeparture),
        confirmed: data.confirmed,
        createdByAutoReply: data.createdByAutoReply,
        datesChanged: data.datesChanged,
        createdAt: parseISO(data.createdAt),
    }
}

export const quoteMapper = (data) => {
    return {
        id: data.id,
        codeNumber: data.codeNumber,
        surname: data.surname,
        name: data.name,
        email: data.email,
        nationality: GeoService.COUNTRIES.find(c => c.code === data.nationality),
        language: data.language,
        adults: data.adults,
        children: data.children,
        petsNumber: data.petsNumber,
        createdAt: parseISO(data.createdAt),
        expiration: parseISO(data.expiration),
        confirmed: data.confirmed,
        createdByAutoReply: data.createdByAutoReply,
        datesChanged: data.datesChanged,
        requestId: data.requestId,

        emailMessage: {
            id: data.emailMessage?.id,
            status: data.emailMessage?.status
        },

        bookingCondition: {
            confirmationPolicy: data.bookingCondition?.confirmationPolicy,
            cancellationPolicy: data.bookingCondition?.cancellationPolicy,
            depositPercentage: data.bookingCondition?.depositPercentage,
            refundableUntil: data.bookingCondition?.refundableUntil ? parseISO(data.bookingCondition?.refundableUntil) : null,
            touristTaxPolicy: data.bookingCondition?.touristTaxPolicy,
            touristTaxUnitPrice: data.bookingCondition?.touristTaxUnitPrice,
        },

        quoteVariants: Array.isArray(data.quoteVariants) ? data.quoteVariants.map(v => quoteVariantMapper(v)) : [],

        getArrival(){
            return this.quoteVariants.reduce(
                (acc, x) => {
                    const quoteArrivalDate = x.getArrival();
                    return quoteArrivalDate < acc ? quoteArrivalDate : acc
                },
                this.quoteVariants.length > 0 ? this.quoteVariants[0].getArrival() : null);
        },

        getDeparture(){
            return this.quoteVariants.reduce(
                (acc, x) => {
                    const quoteDepartureDate = x.getDeparture();
                    return quoteDepartureDate > acc ? quoteDepartureDate : acc
                },
                this.quoteVariants.length > 0 ? this.quoteVariants[0].getDeparture() : null);
        },

        getPriceFrom(){
            return this.quoteVariants.reduce(
                (acc, x) => {
                    const quotePrice = x.getPrice();
                    return quotePrice < acc ? quotePrice : acc
                },
                this.quoteVariants.length > 0 ? this.quoteVariants[0].getPrice() : null);
        }
    }
}

export const quoteVariantMapper = (data) => {
    return {
        id: data.id,
        quoteItems: Array.isArray(data.quoteItems) ? data.quoteItems.map(i => quoteItemMapper(i)) : [],
        confirmed: data.confirmed,

        getPrice(){
            return (this.getPriceCent() / 100).toFixed(2)
        },

        getPriceCent(){
            return this.quoteItems.reduce((acc, i) => acc + i.priceCent, 0)
        },

        getArrival(){
            return this.quoteItems.reduce(
                (acc, x) => x.arrival < acc ? x.arrival : acc,
                this.quoteItems.length > 0 ? this.quoteItems[0].arrival : null);
        },

        getDeparture(){
            return this.quoteItems.reduce(
                (acc, x) => x.departure > acc ? x.departure : acc,
                this.quoteItems.length > 0 ? this.quoteItems[0].departure : null);
        },
    }
}

export const quoteItemMapper = (data) => {
    return {
        id: data.id,
        apartmentId: data.apartmentId,
        arrival: parseISO(data.arrival),
        departure: parseISO(data.departure),
        priceCent: data.priceCent,

        getPrice() {
            return (this.priceCent / 100).toFixed(2);
        }
    }
}

export const apartmentRequestMapper = (data) => {
    return {
        name: data.name,
        surname: data.surname,
        email: data.email,
        nationality: GeoService.COUNTRIES.find(c => c.code === data.nationality),
        language: data.language,
        arrival: data.arrival ? parseISO(data.arrival) : null,
        departure: data.departure ? parseISO(data.departure) : null,
        adults: data.adults ? parseInt(data.adults) : null,
        children: data.children ? parseInt(data.children) : null,
        petsNumber: data.petsNumber ? parseInt(data.petsNumber) : null,
        homeId: data.homeId ? parseInt(data.homeId) : null,
        id: parseInt(data.id),
    }
}